module.exports = __webpack_public_path__ + "static/media/holger_roth.a20f3841.jpg";